module.exports = __webpack_public_path__ + "img/_8_32.prt.9601e78f.jpg";